module.exports = __webpack_public_path__ + "static/img/ts-screen.875cac8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/ts-screen.svg
// module id = dzny
// module chunks = 9